import { render } from "./Login.vue?vue&type=template&id=0a640b7a&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=0a640b7a&scoped=true&lang=css"

import exportComponent from "/Users/shan/www/xnz_merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a640b7a"]])

export default __exports__